export default __webpack_public_path__ + "static/poster@2x-9dd05f41a74766b4b878beb111a56cc6.jpg";